import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const CurrencyList = Loadable(lazy(() => import("features/currency/components/List")));
const CurrencyPage = Loadable(lazy(() => import("features/currency/components/Page")));

const routes = {
    path: 'currency',
    children: [
        { path: '', element: <CurrencyList /> },
        { path: 'add', element: <CurrencyPage /> },
        { path: 'edit/:currencyID?', element: <CurrencyPage /> },
    ]
};

export default routes;